<template>
  <v-container fluid class="the-main">
    
    <!-- PC -->
    <v-carousel class="d-none d-md-block" :show-arrows="false" height="100vh" width="100%" hide-delimiter-background delimiter-icon="mdi-minus" vertical cycle interval="6000">
      <v-carousel-item v-for="(item,i) in itemsRolling" :key="i" :src="item.src" gradient="to top, rgba(0,61,71,.5), rgba(0,0,0,.74)" ripple>
          <v-row class="fill-height" align="center" justify="center">
            <div class="mainvis-txtcon text-center text--white mt-16" style="max-width:50rem">
              <div class="text-h2 white--text font-weight-bold mb-8" v-html="item.title"></div>
              <div class="text-h6 font-weight-light white--text" v-html="item.subtitle"></div>
            </div>
          </v-row>
      </v-carousel-item>
    </v-carousel>

    <!-- MOB -->
    <v-carousel class="d-md-none" :show-arrows="false" height="30rem" width="100%" hide-delimiter-background delimiter-icon="mdi-minus" cycle interval="6000">
      <v-carousel-item v-for="(item,i) in itemsRolling" :key="i" :src="item.src" gradient="to top, rgba(0,61,71,.5), rgba(0,0,0,.74)" ripple>
          <v-row class="fill-height" align="center" justify="center">
            <div class="mainvis-txtcon text-center text--white mt-10 px-10">
              <div class="text-h4 white--text font-weight-bold mb-5" v-html="item.title"></div>
              <div class="text-subtitle-2 font-weight-light white--text" v-html="item.subtitle"></div>
            </div>
          </v-row>
      </v-carousel-item>
    </v-carousel>

    <!-- <section class="main-news res_wrap px-3 my-10 py-0 my-sm-16 py-sm-8">
      <div>
        <h3 class="text-h4 text-sm-h3 font-weight-bold mb-1" style="letter-spacing:-2px !important">JEIN <strong>NEWS</strong></h3>
        <v-row padless no-gutters class="main-sec-content01 ma-0">
          <v-col cols="12" sm="4" >
            <v-img :src="require('@/assets/_tmp_01.png')" contain />
          </v-col>
          <v-col cols="12" sm="8" class="news-text pl-sm-8">
            <dl class="mt-5 mt-sm-0">
              <dt class="text-h6 text-md-h4">JBot Portal (RPA) 소개</dt>
              <dd>Bot 개발, 현황, 개발 표준문서/매뉴얼, 즉시/스케줄링 실행, 상태 모니터링, 장애관리 등 RPA Bot 개발 및 운영에 필요한 관리 메뉴를 제공 합니다.</dd>
            </dl>
            <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more">
              View Detail
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </section> -->

    <section class="main-news res_wrap px-3 my-10 py-0 my-sm-16 py-sm-8">
      <div>
        <h3 class="main-sec-title01 text-h4 text-sm-h3 font-weight-bold mb-4" style="letter-spacing:-2px !important">JEIN <strong>NEWS</strong></h3>
        <!-- PC -->
        <v-carousel height="auto" width="100%" class="d-none d-md-block" show-arrows-on-hover hide-delimiters hide-delimiter-background cycle interval="10000">
          <v-carousel-item v-for="(item,i) in newsRolling" :key="i">
            <v-row padless no-gutters class="main-sec-content01 ma-0">
              <v-col cols="12" sm="4" >
                <v-img :src="item.src" rel="preload" contain height="280" />
              </v-col>
              <v-col cols="12" sm="8" class="news-text pl-sm-8">
                <dl class="mt-5 mt-sm-0">
                  <dt class="text-h6 text-md-h4 text-truncate">{{item.title}}</dt>
                  <dd>{{item.subtitle}}</dd>
                </dl>
                <v-btn :href="item.url" target="_blank" outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more">View Detail</v-btn>
              </v-col>
            </v-row>
          </v-carousel-item>
        </v-carousel>
        <!-- mobile -->
        <v-carousel height="auto" width="100%" class="d-md-none" show-arrows-on-hover hide-delimiters hide-delimiter-background cycle interval="10000">
          <v-carousel-item v-for="(item,i) in newsRolling" :key="i">
            <v-row padless no-gutters class="main-sec-content01 ma-0">
              <v-col cols="12" sm="4" >
                <v-img :src="item.src" rel="preload" contain max-height="280" />
              </v-col>
              <v-col cols="12" sm="8" class="news-text pl-sm-8">
                <dl class="mt-5 mt-sm-0">
                  <dt class="text-h6 text-md-h4">{{item.title}}</dt>
                  <dd>{{item.subtitle}}</dd>
                </dl>
                <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more">View Detail</v-btn>
              </v-col>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </div>
    </section>

    <section class="main-visu-middle">
      <v-parallax class="d-none d-md-block" height="500" padless src="@/assets/bg_main_01.jpg">

        <v-dialog v-model="dialog" width="800">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" > 
              <div class="container-btn">
                <button>
                  <v-icon x-large>mdi-play</v-icon>
                  <p><strong>PRODUCTS</strong>Introduce</p>
                </button>
              </div>
            </div>
          </template>
          <v-card class="pa-2 pb-1">
            <video autoplay controls width="100%" src="@/assets/video_BrityRPA.mp4"></video>
          </v-card>
        </v-dialog>

      </v-parallax>
      <v-parallax class="d-blcok d-md-none" height="350" padless src="@/assets/bg_main_01.jpg">
        
        <v-dialog v-model="dialog" width="100%">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" > 
              <div class="container-btn mob">
                <button>
                  <v-icon x-large>mdi-play</v-icon>
                  <p><strong>PRODUCTS</strong>Introduce</p>
                </button>
              </div>
            </div>
          </template>
          <v-card class="pa-2 pb-1">
            <video autoplay controls width="100%" src="@/assets/video_BrityRPA.mp4"></video>
          </v-card>
        </v-dialog>
        
      </v-parallax>
    </section>

    <!-- <section class="main-product res_wrap px-3 pt-8 pt-sm-16">
      <div class="pt-0 pt-sm-8">
        <h3 class="text-h4 text-sm-h3 font-weight-bold mb-1" style="letter-spacing:-2px !important">JEIN <strong>PRODUCTS</strong></h3>
        <v-row padless no-gutters class="main-sec-content02 ma-0">
          <v-col cols="12" md="6" class="product-text">
            <dl>
              <dt class="text-subtitle-1 text-md-h5 my-2">JBot Portal (RPA)</dt>
              <dd>Bot 개발, 현황, 개발 표준문서/매뉴얼, 즉시/스케줄링 실행, 상태 모니터링, 장애관리 등 RPA Bot 개발 및 운영에 필요한 관리 메뉴를 제공 합니다.</dd>
            </dl>
            <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more">
              View Detail
            </v-btn>
            <dl class="mt-5">
              <dt class="text-subtitle-1 text-md-h5 my-2">Automation Anywhere (RPA)</dt>
              <dd>인간에 의해 이뤄진 Do/ Think/ Analyze 작업을 대체하여 주는 자동화 솔루션. 사람이 반복적으로 처리하는 단순 업무를 로봇 소프트웨어인 봇(Bot)을 통해 대신 수행</dd>
            </dl>
            <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more">
              View Detail
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" class="pl-sm-8 mt-5 mt-md-0" >
            <v-img :src="require('@/assets/_tmp_02.jpg')" contain />
          </v-col>
        </v-row>
      </div>
    </section> -->
    
    <section class="main-product res_wrap px-3 pt-8 pt-sm-16">
      <div>
        <h3 class="main-sec-title02 text-h4 text-sm-h3 font-weight-bold mb-5" style="letter-spacing:-2px !important">JEIN <strong>PRODUCTS</strong></h3>
        <div class="main-sec-content02">
          <v-tabs class="d-none d-sm-block" grow v-model="tabs">
            <v-tab href="#tab-1">Jein</v-tab>
            <v-tab href="#tab-2">Samsung SDS</v-tab>
            <v-tab href="#tab-3">TIBCO</v-tab>
          </v-tabs>
          
          <!-- mobile -->
          <v-tabs class="d-sm-none mob" grow vertical v-model="tabs">
            <v-tab href="#tab-1">Jein</v-tab>
            <v-tab href="#tab-2">Samsung SDS</v-tab>
            <v-tab href="#tab-3">TIBCO</v-tab>
          </v-tabs>
          
          <!-- image cache loading -->
          <img src="@/assets/img_main_product_01.svg" style="display:none; " />
          <img src="@/assets/img_main_product_03.jpg" style="display:none; " />
          <img src="@/assets/img_sub_prod_tibco01.svg" style="display:none; " />

          <v-tabs-items v-model="tabs" class="mt-10">
            <v-tab-item value="tab-1">
              <v-row padless no-gutters class="main-sec-content02 ma-0">
                <v-col cols="12" md="6" class="product-text">
                  <dl>
                    <dt class="text-subtitle-1 text-md-h5 my-2">JBot(RPA)</dt>
                    <dd>자동화 업무를 정의하는 JBot Designer<br>업무 수행 결과를 모니터링 및 관리할 수 있는 Manager Web<br>자동화 업무를 수행하는 JBot Engine</dd>
                  </dl>
                  <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more" :to="{name:'jbot'}" exact>View Detail</v-btn>
                  <dl class="mt-5">
                    <dt class="text-subtitle-1 text-md-h5 my-2">JBot Portal(RPA)</dt>
                    <dd>Bot 개발, 현황, 개발 표준문서/매뉴얼, 즉시/스케줄링 실행, 상태 모니터링, 장애관리 등 RPA Bot 개발 및 운영에 필요한 관리 메뉴를 제공</dd>
                  </dl>
                  <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more" :to="{name:'jbotportal'}" exact>View Detail</v-btn>
                  <dl class="mt-5">
                    <dt class="text-subtitle-1 text-md-h5 my-2">Auto-Station</dt>
                    <dd>Digital 기술의 연계로 자동화 프로세스를 구축하고, 실행하며, 모니터링 할 수 있는 플랫폼<br>RPA, OCR, 챗봇, Machine Learning 등 자동화 솔루션에서 구현된 자동화 업무 연계</dd>
                  </dl>
                  <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more" :to="{name:'autostation'}" exact>View Detail</v-btn>
                </v-col>
                <v-col cols="12" md="6" class="pl-sm-8 mt-5 mt-md-0" >
                  <v-img :src="require('@/assets/img_main_product_01.svg')" contain max-height="500" />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-row padless no-gutters class="main-sec-content02 ma-0">
                <v-col cols="12" md="6" class="product-text">
                  <dl>
                    <dt class="text-subtitle-1 text-md-h5 my-2">Brity RPA</dt>
                    <dd>사람이 반복적으로 처리하는 업무를 AI 기술이 결합된<br>S/W 로봇을 통해 자동화</dd>
                  </dl>
                  <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more" :to="{name:'brityrpa'}" exact>View Detail</v-btn>
                  <dl class="mt-5">
                    <dt class="text-subtitle-1 text-md-h5 my-2">Brity Assistant</dt>
                    <dd>사용자의 질문 의도를 파악한 후, 원하는 답변을 제공해주거나 특정 업무를 실행해주는<br>챗봇을 통한 업무비서</dd>
                  </dl>
                  <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more" :to="{name:'brityassistant'}" exact>View Detail</v-btn>
                </v-col>
                <v-col cols="12" md="6" class="pl-sm-8 mt-5 mt-md-0" >
                  <v-img :src="require('@/assets/img_main_product_03.jpg')" contain max-height="320" />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <v-row padless no-gutters class="main-sec-content02 ma-0">
                <v-col cols="12" md="6" class="product-text">
                  <dl>
                    <dt class="text-subtitle-1 text-md-h5 my-2">TIBCO</dt>
                    <dd>TIBCO는 이질적인 시스템들의 연계 (connect) , 데이터의 통합 (unify) , 고급 분석을 통해 미래를 예측 (predict) 하기 위한 선진 솔루션을 제공해 난제를 해결하도록 지원</dd>
                  </dl>
                  <v-btn outlined plain height="2.75rem" class="text-capitalize mt-5 align-self-stretch align-self-sm-start btn-main-more" :to="{name:'tibco'}" exact>View Detail</v-btn>
                </v-col>
                <v-col cols="12" md="6" class="pl-sm-8 mt-5 mt-md-0" >
                  <v-img :src="require('@/assets/img_sub_prod_tibco01.svg')" contain max-height="140" />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </section>

    <section class="main-partner res_wrap px-3 mt-10 pt-0 mt-sm-16 pt-sm-8">
      <div>
        <h3 class="main-sec-title03 text-h4 text-sm-h3 font-weight-bold mb-1" style="letter-spacing:-2px !important">PARTNERS</h3>

        <v-row class="align-stretch mt-4">
          <v-col cols="4" md="2" sm="3" class="d-flex align-stretch" v-for="(item, index) in cards" :key="index">
            <v-card class="d-flex align-center justify-center rounded-lg px-4 partner-logos" outlined width="100%">
              <img :src="item.src" />
            </v-card>
          </v-col>
        </v-row>

      </div>
    </section>

  </v-container>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

  export default {
    name: 'the-main',
    components: {
    },
    data: () => ({
      tabs: null,
      itemsRolling: [
        {
          src: require("@/assets/img_main_01.jpg"),
          title: '<strong>Step Up</strong> with Digital Wave',
          subtitle: '비즈니스 활동이 일어나는 모든 영역에서 “고객에게 가치를 제공하고 신뢰받는 최고의 솔루션과 지식 서비스 기업"  (주)제인소프트 입니다. 고객의 혁신을 이끄는 기업이 되겠습니다.',
        },
        {
          src: require("@/assets/img_main_02.jpg"),
          title: 'May be...? <strong>Must be!</strong>',
          subtitle: '(주)제인소프트는 2017년 RPA 국내 도입 초기부터 컨설팅 및 구축 전문기업으로 관련 노하우를 축적해왔으며, AI 육성 사업 지정업체로 선정되어 AI 기반의 Hyperautomation 제품 개발을 진행중인 Digital Transformation 선도 기업입니다.',
        },
      ],
      newsRolling: [
        {
          src: 'https://www.breaknews.com/imgdata/breaknews_com/202104/2021040517274221.jpg',
          title: '삼성전자, 경영혁신 지원 차세대 ‘N-ERP’ 시스템 도입',
          subtitle: '삼성전자는 차세대 ERP(Enterprise Resource Planning, 전사자원관리) 시스템인 ‘N-ERP’를 구축해 도입했다고 5일 밝혔다. 삼성전자는 새로운 비즈니스의 등장과 융복합화 등 미래 경영환경의 변화를 지원할 수 있는 혁신 플랫폼을 마련하기 위해 최신 기술의 전문 ERP 솔루션 패키지를 기반으로 30개월간 이 시스템을 개발했다. 이 시스템은 동/서남아, 중국 법인에서 우선 적용됐고, 내년 1월까지 전세계 법인에 순차적으로 도입될 예정이다.',
          url: 'https://www.breaknews.com/797252',
        },
        {
          src: 'https://img.etnews.com/photonews/1811/1133392_20181128170007_714_0001.jpg',
          title: '삼성전자, 직원 단순업무 줄이는 SW 선정...국내 RPA 시장 커진다',
          subtitle: '삼성전자가 로봇프로세스자동화(RPA) 표준 솔루션을 선정했다. 소프트웨어(SW)가 직원 단순 업무를 대신, 업무 효율성을 높인다. 삼성전자를 필두로 국내 주요 대기업에 RPA 도입이 확산할 것으로 전망된다. 28일 업계에 따르면 삼성전자는 최근 글로벌 업체 A사 제품을 RPA 표준 솔루션으로 선정했다. RPA는 사람이 단순 반복하던 업무를 대신 처리해 주는 SW다. 단순 데이터 입력, 검색 등 반복 수작업 업무를 SW가 자동으로 처리한다. 직원은 단순 반복 업무에서 벗어나 창의, 생산 업무에 집중한다. RPA는 업무 효율성과 생산성을 높인다는 점에서 전 세계에 확산되는 추세다.',
          url: 'https://www.etnews.com/20181128000386',
        },
        {
          src: 'https://img.etnews.com/photonews/1906/1198274_20190625142335_699_0001.jpg',
          title: 'KT "일잘하는 ‘전대리’ ‘마비서’ 덕에 연 70억 절감"',
          subtitle: 'KT가 로보틱 프로세스 자동화(RPA) ‘콜라봇’ 사업에 드라이브를 건다. 영수증 처리 등 단순반복 업무를 자동화해 전사적으로 연간 27만 시간을 절약한 경쟁력을 토대로 기업고객을 확보한다. 오인택 KT 상무(IT기획실 고객경영플랫폼 담당)는 최근 “KT RPA 서비스는 직원 업무를 코딩해 자동화한 형태 패턴으로 고객 맞춤형 지원이 가능하다”며 “데이터를 분석하고 처리하는 일, 영상을 편집하는 일 등 손은 많이 가지만 단순한 사내 업무를 지원한다”고 설명했다.',
          url: 'https://www.etnews.com/20190625000205',
        },
        {
          src: 'https://img.hankyung.com/photo/202008/AA.23377217.1.jpg',
          title: 'KT, 로봇 직원 ‘전대리’ ‘마비서’가 단순 업무 척척',
          subtitle: 'KT는 단순 반복 업무를 자동화해 업무 효율을 높이고 있다. 소프트웨어(SW) 로봇 직원인 전대리, 마비서, 서검사 등을 도입한 게 대표적이다. 전대리는 전표를 대신 처리해주는 전표 처리 로봇이다. 2018년 8월 업무에 도입됐다. 전대리는 동일한 내용을 반복적으로 입력해야 하는 법인카드 전표 생성을 챗봇 기반 사용자환경(UI)을 통해 쉽고 빠르게 처리한다. 이전에는 사무실에서 영수증을 스캔해 전사적자원관리(ERP) 솔루션에 업로드하고 비용항목 등을 하나하나 반복 입력해야 했던 작업이다.',
          url: 'https://www.hankyung.com/it/article/2020080353111',
        },
      ],
      cards: [
        // { src: require("@/assets/logos_partner_01.svg"), },
        // { src: require("@/assets/logos_partner_02.svg"), },
        // { src: require("@/assets/logos_partner_03.svg"), },
        // { src: require("@/assets/logos_partner_04.svg"), },
        // { src: require("@/assets/logos_partner_05.svg"), },
        // { src: require("@/assets/logos_partner_06.svg"), },
        // { src: require("@/assets/logos_partner_07.svg"), },
        // { src: require("@/assets/logos_partner_08.svg"), },
        // { src: require("@/assets/logos_partner_09.svg"), },
        // { src: require("@/assets/logos_partner_10.svg"), },
        // { src: require("@/assets/logos_partner_11.svg"), },
        { src: require("@/assets/logos_partner_12.svg"), },
        { src: require("@/assets/logos_partner_13.svg"), },
        // { src: require("@/assets/logos_partner_14.svg"), },
        // { src: require("@/assets/logos_partner_15.svg"), },
        { src: require("@/assets/logos_partner_16.svg"), },
        { src: require("@/assets/logos_partner_17.svg"), },
        { src: require("@/assets/logos_partner_18.svg"), },
        { src: require("@/assets/logos_partner_19.svg"), },
        { src: require("@/assets/logos_partner_20.svg"), },
      ],
    }),
    mounted: function(){
      gsap.from(".main-sec-title01", {
        scrollTrigger: {
          trigger: ".main-sec-title01",
          toggleActions: "restart none none none"
        },
        duration: 1, opacity: 0, y: -30, stagger: .05,
      });
      gsap.from(".main-sec-content01", {
        scrollTrigger: {
          trigger: ".main-sec-content01",
          toggleActions: "restart none none none"
        },
        duration: 1, opacity: 0, y: 30, delay:.3, stagger: .05,
      });
      gsap.from(".main-sec-title02", {
        scrollTrigger: {
          trigger: ".main-sec-title02",
          toggleActions: "restart none none none"
        },
        duration: 1, opacity: 0, y: -30, stagger: .05,
      });
      gsap.from(".main-sec-content02", {
        scrollTrigger: {
          trigger: ".main-sec-content02",
          toggleActions: "restart none none none"
        },
        duration: 1, opacity: 0, y: 30, delay:.3, stagger: .05,
      });
      gsap.from(".main-sec-title03", {
        scrollTrigger: {
          trigger: ".main-sec-title03",
          toggleActions: "restart none none none"
        },
        duration: 1, opacity: 0, y: -30, stagger: .05,
      });
      gsap.from(".v-card", {
        scrollTrigger: {
          trigger: ".v-card",
          toggleActions: "restart none none none"
        },
        duration: .7, opacity: 0, y: 30, stagger: .05,
      });
    },
  }
</script>

<style lang="scss" scoped>
</style>